import React, { useState } from "react";
import { Menu, Dropdown, Button, Space , Row , Col, Avatar, Drawer } from "antd";
import { UserOutlined, DownOutlined, LogoutOutlined, HomeOutlined, CalendarOutlined, SettingOutlined, MenuOutlined } from "@ant-design/icons";
import {Link} from 'react-router-dom'

function DefaultLayout(props) {
    const user = JSON.parse(localStorage.getItem('user'))
    const [drawerOpen, setDrawerOpen] = useState(false)
  const menu = (
    <Menu>
      <Menu.Item onClick={()=>{
          localStorage.removeItem('user');
          window.location.href='/login'
      }}>
          <span style={{color:'#4f46e5'}}><LogoutOutlined /> &nbsp;Logout</span>
      </Menu.Item>
    </Menu>
  );
  return (
    <div>
      <div className="header bs1">
          <Row gutter={16} justify='center'>
              <Col lg={20} sm={24} xs={24}>
              <div className="d-flex justify-content-between align-items-center navbar-inner">

                 <h1 className="brand-logo"><b><Link to='/' style={{color:'#4f46e5'}}>🚗 SwiftWheels</Link></b></h1>

                 <div className="nav-links">
                     <Link to='/' className="nav-link"><HomeOutlined /> Home</Link>
                     <Link to='/userbookings' className="nav-link"><CalendarOutlined /> Bookings</Link>
                     {user.role === 'admin' && <Link to='/admin' className="nav-link"><SettingOutlined /> Admin</Link>}
                 </div>

                 <div className="nav-right">
                     <Dropdown overlay={menu} placement="bottomRight">
                       <div className="user-chip">
                           <Avatar size="small" icon={<UserOutlined />} style={{backgroundColor:'#4f46e5'}}/>
                           <span className="user-name">{user.username}</span>
                           <DownOutlined style={{fontSize:'10px'}}/>
                       </div>
                     </Dropdown>

                     <button className="hamburger-btn" onClick={()=>setDrawerOpen(true)}>
                         <MenuOutlined />
                     </button>
                 </div>
        </div>
              </Col>
          </Row>
        
      </div>

      <Drawer
        title={<span style={{color:'#4f46e5'}}>🚗 Car Rental</span>}
        placement="right"
        onClose={()=>setDrawerOpen(false)}
        open={drawerOpen}
      >
          <div className="drawer-links">
              <Link to='/' onClick={()=>setDrawerOpen(false)}><HomeOutlined /> Home</Link>
              <Link to='/userbookings' onClick={()=>setDrawerOpen(false)}><CalendarOutlined /> Bookings</Link>
              {user.role === 'admin' && <Link to='/admin' onClick={()=>setDrawerOpen(false)}><SettingOutlined /> Admin</Link>}
              <a onClick={()=>{
                  localStorage.removeItem('user');
                  window.location.href='/login'
              }}><LogoutOutlined /> Logout</a>
          </div>
      </Drawer>

      <div className="content">{props.children}</div>

      <div className="footer text-center">
      <hr />

           <p>Designed and Developed By Adarsh Mulik 🚗</p>
          
      </div>
    </div>
  );
}

export default DefaultLayout;
